<template>
  <div class="main">
    <column-title title="Research"></column-title>
    <p>The Chen research group is focused on electrochemistry (battery and catalyst), nanomaterials and
      nanotechnology
      to
      address crucial challenges in energy storage and production systems. Central to our vision for the sustainable
      future
      is the synthesis of new nanomaterials and the fabrication of novel nanostructures for the development of
      next-generation energy storage and production systems, as well as investigating and understanding fundamental
      questions in the energy field. We are currently focused on the following three major areas:
    </p>
    <div class="content">
      <div>
        1. Batteries

        <p>The Chen research group is interested in the development of new battery chemistry with an emphasis on the
          grid-scale energy storage application.
        </p>
        2. Catalysis

        <p>The Chen research group is pursuing a broad range of studies focused on the synthesis of new catalysts with
          good
          electrocatalytic activities and the development of novel energy production system to convert small molecules
          to
          valuable fuels, as well as the fabrication of new platforms to explore some fundamental phenomenon in the
          catalytic
          process.
        </p>
        3. Nanomaterials

        <p>The Chen research group is focused on the synthesis of new nanomaterials and the development of novel
          nanostructures with unique electrochemical properties that can enable revolutionary advances in energy storage
          and
          production applications.
        </p>
      </div>
      <div class="image"><img :src="research" class="image"></div>
    </div>
  </div>
</template>

<script>
import ColumnTitle from "@/components/ColumnTitle";
import research from "@/assets/images/research.png"

export default {
  name: "Research",
  components: {ColumnTitle},
  data() {
    return {
      research
    }
  }
}
</script>

<style scoped>
.main {
  width: 80%;
  margin: auto;

}
.content{
  display: flex;
}

.image {
  width: 30vw;
}
</style>